// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-profile-freelance{padding-block:3rem;gap:10px}@media (max-width: 767.98px){.container-profile-freelance{padding-block:0.5rem;gap:0;padding-inline:5px}.container-profile-freelance .fl-pages{padding-inline:0.2rem}}\n", ""]);
// Exports
module.exports = exports;
